import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      minHeight: 48,
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      justifyContent: 'start',
      gap: theme.spacing(1),
      padding: theme.spacing(2, 1.5),
      backgroundColor: COLORS.neutral.white,
      border: theme.shape.borderPrimaryLight,
      borderRadius: theme.shape.borderRadius,

      '&$selected': {
        borderColor: COLORS.primary.default,
        backgroundColor: COLORS.primary.silver,
      },
      '&:disabled': {
        borderColor: COLORS.gray.gray60,

        '&$selected': {
          borderColor: COLORS.primary.light,
        },

        '& $title': {
          color: COLORS.gray.gray40,
        },
      },
      '&:hover, &:focus': {
        borderColor: COLORS.primary.default,
      },
    },
    selected: {},

    radio: {
      padding: 0,
    },
    content: {
      display: 'flex',
      flexFlow: 'column nowrap',
      gap: theme.spacing(0.25),
    },
    title: {
      textAlign: 'left',
      color: COLORS.gray.black,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
    description: {
      color: COLORS.gray.gray40,
      textAlign: 'left',
      whiteSpace: 'pre-wrap',
    },
  }),
  { name: 'ButtonImproveMode' }
);
